import { defineMessages } from "react-intl";

/**
 * SFCC-11735 — i18n catalog for the search Products/Articles tab UI. Externalized
 * from hardcoded EN (originally inlined by SFCC-11499) to align with the broader
 * Learning Center i18n externalization (SFCC-11723). Consumed by the tab bar in
 * `shop.$categoryId.tsx` and the empty state in `search-articles-tab.tsx`.
 */
const messages = defineMessages({
  productsTab: {
    id: "search.tabs.products",
    defaultMessage: "Products",
  },
  articlesTab: {
    id: "search.tabs.articles",
    defaultMessage: "Articles ({count})",
  },
  noArticles: {
    id: "search.articles.empty",
    defaultMessage: "No articles found.",
  },
});

export default messages;
